<template>
  <div id="app">
    <router-view id="containerBox" />
  </div>
</template>
<script>
//
import { interfaceObj } from "@/urlConfig";
//页面头部
//import HeadNav from "@/components/headNav";
export default {
  name: "Home",
  //components: { HeadNav },
  created() {
    let winHref = window.location.href;
    if (winHref.indexOf("user_access_token") > -1) {
      let urlParam = winHref.split("?")[1].split("=")[1];
      console.log(urlParam);
      this.axios
        .post(interfaceObj.login, { user_access_token: urlParam })
        .then((res) => {
          this.$store.commit("setUserValue", res.data.data);
        });
    }
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  #containerBox {
    width: 100%;
    margin: auto;
    padding-top: 0.74rem;
  }
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
